(function () {
  /* Este archivo se enlaza desde varias secciones: que solo se ejecute una vez */
  if (window.__mtCargado) return;
  window.__mtCargado = true;

  /* ---------- Selector cartera | cinturón: precarga la foto del otro producto y responde al instante al tocar ---------- */
  function initSelector() {
    document.querySelectorAll('.mt-selector__op[data-mt-precargar]').forEach(function (a) {
      var precargar = function () {
        if (a.dataset.mtHecho) return; a.dataset.mtHecho = '1';
        a.getAttribute('data-mt-precargar').split('|').forEach(function (src) { var i = new Image(); i.decoding = 'async'; i.src = src; });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(precargar, { timeout: 3000 }); else setTimeout(precargar, 1500);
      a.addEventListener('pointerdown', precargar, { passive: true });
      a.addEventListener('click', function () {
        var sel = a.closest('.mt-selector');
        if (!sel) return;
        sel.querySelectorAll('.mt-selector__op').forEach(function (o) { o.classList.toggle('is-activo', o === a); });
        sel.classList.add('is-cambiando');
      });
    });
    /* al volver atrás desde el otro producto, el selector vuelve a su estado */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      document.querySelectorAll('.mt-selector').forEach(function (sel) {
        sel.classList.remove('is-cambiando');
        sel.querySelectorAll('.mt-selector__op').forEach(function (o) { o.classList.toggle('is-activo', o.hasAttribute('aria-current')); });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initSelector);

  /* ---------- Ofertas del carrito: la ✕ las oculta durante la visita (sigue oculta aunque el carrito se vuelva a pintar) ---------- */
  ['pack', 'cruzada', 'kit'].forEach(function (tipo) {
    try { if (sessionStorage.getItem('mt-oferta-oculta-' + tipo)) document.documentElement.classList.add('mt-sin-oferta-' + tipo); } catch (e) {}
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mt-oferta-cerrar]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var tipo = b.getAttribute('data-mt-oferta-cerrar');
    document.documentElement.classList.add('mt-sin-oferta-' + tipo);
    try { sessionStorage.setItem('mt-oferta-oculta-' + tipo, '1'); } catch (err) {}
  });

  /* ---------- Oferta del carrito: añadir el otro producto de la marca (por separado) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mt-anadir]') : null;
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.classList.add('is-cargando');
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(raiz + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-id'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      var drawer = document.querySelector('cart-drawer');
      if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
      b.disabled = false; b.classList.remove('is-cargando');
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else window.location.href = raiz + 'cart';
    }).catch(function () { window.location.reload(); });
  });

  /* ---------- Oferta del carrito lateral: cambiar al siguiente pack ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mt-upsell]') : null;
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    b.classList.add('is-cargando');
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    /* data-key puede llevar varias líneas separadas por comas (cambiar 2-3 productos por el Kit Nómada) */
    var claves = (b.getAttribute('data-key') || '').split(',').filter(Boolean), quitar = {};
    claves.forEach(function (k) { quitar[k] = 0; });
    fetch(raiz + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: quitar }) })
      .then(function () {
        return fetch(raiz + 'cart/add.js', {
          method: 'POST', headers: json,
          body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-id'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var drawer = document.querySelector('cart-drawer');
        /* En la página del carrito se recarga para ver el pack nuevo en la lista */
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = raiz + 'cart';
        }
      })
      .catch(function () { window.location.reload(); });
  });

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll + cifras ---------- */
  var observer = null;
  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mt-visible');
        if (e.target.hasAttribute('data-mt-contar')) contar(e.target);
        observer.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    return observer;
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, [data-mt-contar]');
    var obs = getObserver();
    els.forEach(function (el) {
      if (reduce || !obs) { el.classList.add('mt-visible'); return; }
      obs.observe(el);
    });
  }

  function contar(el) {
    var fin = parseFloat(String(el.getAttribute('data-mt-contar')).replace(',', '.'));
    if (isNaN(fin) || reduce) return;
    var decimales = (String(el.getAttribute('data-mt-contar')).split(/[.,]/)[1] || '').length;
    var inicio = null, dur = 1600;
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / dur, 1);
      var v = fin * (1 - Math.pow(1 - p, 3));
      el.textContent = v.toFixed(decimales).replace('.', ',');
      if (p < 1) requestAnimationFrame(paso);
    }
    el.textContent = '0';
    requestAnimationFrame(paso);
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var intensidad = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * intensidad * -1 - intensidad / 2).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    var cont = (root || document).querySelector('[data-mt-producto]');
    if (!cont || cont.dataset.mtListo) return;
    cont.dataset.mtListo = '1';

    var datosEl = cont.querySelector('[data-mt-variantes]');
    var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
    var formato = cont.getAttribute('data-mt-moneda') || '{{amount}}';
    var principal = cont.querySelector('[data-mt-principal]');
    var minis = Array.prototype.slice.call(cont.querySelectorAll('[data-mt-mini]'));
    var indice = 0;

    function dinero(cents) {
      var n = (cents / 100);
      var conComa = n.toFixed(2).replace('.', ',');
      var conPunto = n.toFixed(2);
      return formato
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n))
        .replace(/\{\{\s*amount\s*\}\}/, conPunto);
    }

    function mostrar(i) {
      if (!minis.length || !principal) return;
      indice = (i + minis.length) % minis.length;
      var m = minis[indice];
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = m.getAttribute('data-src');
        principal.srcset = m.getAttribute('data-srcset') || '';
        principal.alt = m.getAttribute('data-alt') || '';
        principal.style.opacity = '1';
      }, 180);
      minis.forEach(function (b, j) { b.classList.toggle('is-activa', j === indice); });
    }
    minis.forEach(function (b, j) { b.addEventListener('click', function () { mostrar(j); }); });
    var prev = cont.querySelector('[data-mt-prev]'), next = cont.querySelector('[data-mt-next]');
    if (prev) prev.addEventListener('click', function () { mostrar(indice - 1); });
    if (next) next.addEventListener('click', function () { mostrar(indice + 1); });

    /* Foto principal: deslizar con el dedo para cambiarla y tocarla para verla a pantalla completa */
    function deslizable(el, alCambiar) {
      var x0 = null, y0 = null;
      el.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) { x0 = null; return; } x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (window.visualViewport && window.visualViewport.scale > 1.05) return;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { el.dataset.mtDeslizado = '1'; alCambiar(dx < 0 ? 1 : -1); }
      });
    }
    function abrirVisor() {
      var i = indice;
      var antes = document.activeElement;
      var v = document.createElement('div');
      v.className = 'mt-visor mt-visor--prod';
      v.setAttribute('role', 'dialog');
      v.setAttribute('aria-modal', 'true');
      v.innerHTML = '<button type="button" class="mt-visor__cerrar" aria-label="×">×</button>' +
        (minis.length > 1 ? '<button type="button" class="mt-visor__flecha mt-visor__flecha--prev" aria-label="‹">‹</button><button type="button" class="mt-visor__flecha mt-visor__flecha--next" aria-label="›">›</button>' : '') +
        '<img alt=""><p class="mt-visor__cuenta"></p>';
      var img = v.querySelector('img'), cuenta = v.querySelector('.mt-visor__cuenta');
      function ver(j) {
        if (!minis.length) { img.src = principal.currentSrc || principal.src; return; }
        i = (j + minis.length) % minis.length;
        img.src = (minis[i].getAttribute('data-src') || '').replace(/width=\d+/, 'width=1800');
        img.alt = minis[i].getAttribute('data-alt') || '';
        cuenta.textContent = (i + 1) + ' / ' + minis.length;
      }
      function cerrar() {
        document.removeEventListener('keydown', teclas);
        document.documentElement.style.overflow = '';
        v.remove();
        if (minis.length && i !== indice) mostrar(i);
        if (antes && antes.focus) antes.focus();
      }
      function teclas(e) {
        if (e.key === 'Escape') cerrar();
        else if (e.key === 'ArrowRight') ver(i + 1);
        else if (e.key === 'ArrowLeft') ver(i - 1);
      }
      v.addEventListener('click', function (e) {
        var t = e.target;
        if (t === v || t.classList.contains('mt-visor__cerrar')) cerrar();
        else if (t.classList.contains('mt-visor__flecha--prev')) ver(i - 1);
        else if (t.classList.contains('mt-visor__flecha--next')) ver(i + 1);
      });
      deslizable(img, function (paso) { ver(i + paso); });
      document.addEventListener('keydown', teclas);
      document.documentElement.style.overflow = 'hidden';
      document.body.appendChild(v);
      ver(i);
      v.querySelector('.mt-visor__cerrar').focus();
    }
    if (principal) {
      principal.classList.add('mt-prod__ampliable');
      if (minis.length > 1) deslizable(principal, function (paso) { mostrar(indice + paso); });
      principal.addEventListener('click', function () {
        if (principal.dataset.mtDeslizado) { delete principal.dataset.mtDeslizado; return; }
        abrirVisor();
      });
    }

    var inputId = cont.querySelector('input[name="id"]');
    var precio = cont.querySelector('[data-mt-precio]');
    var antes = cont.querySelector('[data-mt-antes]');
    var ahorro = cont.querySelector('[data-mt-ahorro]');
    var boton = cont.querySelector('[data-mt-boton]');
    var botonTexto = cont.querySelector('[data-mt-boton-texto]');
    var barraPrecio = document.querySelector('[data-mt-barra-precio]');
    var barraPack = document.querySelector('[data-mt-barra-pack]');
    /* Empujones al pack siguiente (uno por pack): al pulsar, se elige el pack de arriba y su tarjeta se ilumina */
    var empujones = cont.querySelectorAll('[data-mt-empujon]');
    empujones.forEach(function (empujon) {
      empujon.addEventListener('click', function () {
        var r = cont.querySelector('[data-mt-pack][value="' + empujon.getAttribute('data-id') + '"]');
        if (!r) return;
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        var tarjeta = r.closest('.mt-pack');
        if (tarjeta) { tarjeta.classList.add('mt-pack--destello'); setTimeout(function () { tarjeta.classList.remove('mt-pack--destello'); }, 1900); }
      });
    });

    function aplicar(id, inicial) {
      var v = variantes.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (inputId) inputId.value = v.id;
      if (precio) precio.textContent = dinero(v.price);
      if (barraPrecio) barraPrecio.textContent = dinero(v.price);
      var radio = cont.querySelector('[data-mt-pack][value="' + v.id + '"]');
      if (barraPack) {
        var chip = radio && radio.closest('.mt-pack') ? radio.closest('.mt-pack').querySelector('.mt-pack__ahorro') : null;
        var nombreBarra = barraPack.getAttribute('data-nombre');
        barraPack.textContent = (nombreBarra ? nombreBarra + ' · ' : '') + v.title;
        if (chip && chip.textContent.trim()) {
          var verde = document.createElement('em');
          verde.className = 'mt-barra__ahorro';
          verde.textContent = chip.textContent.trim();
          barraPack.appendChild(verde);
        }
      }
      var ref = radio ? (parseInt(radio.getAttribute('data-ref'), 10) || 0) : 0;
      var tachado = Math.max(v.compare_at_price || 0, ref);
      if (antes) { antes.textContent = tachado > v.price ? dinero(tachado) : ''; }
      /* El tachado de los packs es el precio de comprar las carteras sueltas: se dice "por separado" */
      var antesNota = cont.querySelector('[data-mt-antes-nota]');
      if (antesNota) antesNota.hidden = !(ref > v.price && ref >= (v.compare_at_price || 0));
      if (ahorro) {
        if (tachado > v.price) {
          ahorro.hidden = false;
          ahorro.textContent = (ahorro.getAttribute('data-plantilla') || 'Ahorras [x]').replace('[x]', dinero(tachado - v.price));
        } else { ahorro.hidden = true; }
      }
      if (boton) {
        boton.disabled = !v.available;
        if (botonTexto) {
          var ok = botonTexto.getAttribute('data-ok');
          if (botonTexto.getAttribute('data-precio-en-boton') === 'true') ok += ' · ' + dinero(v.price);
          botonTexto.textContent = v.available ? ok : botonTexto.getAttribute('data-agotado');
        }
      }
      empujones.forEach(function (e) { e.hidden = String(v.id) !== e.getAttribute('data-desde'); });
      if (!inicial && v.featured_media_id && minis.length) {
        minis.forEach(function (b, j) { if (b.getAttribute('data-media-id') === String(v.featured_media_id)) mostrar(j); });
      }
      if (window.history && window.history.replaceState && !(window.Shopify && window.Shopify.designMode) && window.location.pathname.indexOf('/products/') !== -1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    cont.querySelectorAll('[data-mt-pack]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) aplicar(r.value); });
    });
    var marcado = cont.querySelector('[data-mt-pack]:checked');
    if (marcado) aplicar(marcado.value, true);

    /* Zona de compra en pantalla (packs, botones, envío): el botón flotante de ayuda se aparta en móvil */
    var zonas = cont.querySelectorAll('.mt-prod__form, .mt-compartir, .mt-envio');
    if (zonas.length && 'IntersectionObserver' in window) {
      var enVista = new Set();
      var obsZona = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) enVista.add(e.target); else enVista.delete(e.target); });
        document.documentElement.classList.toggle('mt-caja-visible', enVista.size > 0);
      });
      zonas.forEach(function (z) { obsZona.observe(z); });
    }

    /* La primera vez que se ven los packs, la tarjeta recomendada (Parejas) se ilumina una vez */
    var packsCaja = cont.querySelector('.mt-packs');
    var tarjetas = cont.querySelectorAll('.mt-pack');
    if (packsCaja && tarjetas.length > 1 && 'IntersectionObserver' in window && !reduce) {
      var obsPacks = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          obsPacks.disconnect();
          var t = tarjetas[1];
          var r = t.querySelector('[data-mt-pack]');
          if (r && r.checked) return;
          setTimeout(function () {
            t.classList.add('mt-pack--destello');
            setTimeout(function () { t.classList.remove('mt-pack--destello'); }, 1900);
          }, 400);
        });
      }, { threshold: 0.6 });
      obsPacks.observe(packsCaja);
    }

    var cant = cont.querySelector('[data-mt-cantidad]');
    if (cant) {
      cont.querySelector('[data-mt-menos]').addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1); });
      cont.querySelector('[data-mt-mas]').addEventListener('click', function () { cant.value = (parseInt(cant.value, 10) || 1) + 1; });
    }

    /* Añadir al carrito sin cambiar de página: abre el carrito lateral de Dawn */
    var form = cont.querySelector('form[action*="/cart/add"]');
    var errorEl = cont.querySelector('[data-mt-error]');
    if (form && cont.getAttribute('data-mt-lateral') === 'true') {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        boton.classList.add('is-cargando');
        var fd = new FormData(form);
        fd.delete('mt-pack');
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (errorEl) { errorEl.textContent = res.description || res.message || (window.mtTextos && window.mtTextos.error_anadir) || 'No se pudo añadir. Inténtalo de nuevo.'; errorEl.hidden = false; }
              return;
            }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { boton.classList.remove('is-cargando'); });
      });
    }

    /* Barra fija móvil: aparece cuando la caja de compra no está en pantalla y lleva hasta ella */
    var barra = document.querySelector('[data-mt-barra]');
    var caja = cont.querySelector('.mt-prod__info');
    if (barra && caja && 'IntersectionObserver' in window) {
      /* En móvil la caja usa display:contents (no tiene tamaño): la barra queda fija siempre que se ha bajado un poco,
         el usuario la quiere siempre a mano. En ordenador se oculta mientras se ve la columna de compra. */
      var siempre = getComputedStyle(caja).display === 'contents';
      var cajaVisible = !siempre;
      /* En ordenador: la barra sale siempre que el botón de compra no está en pantalla, también al entrar
         (en portátiles los packs quedan por debajo de la primera pantalla) */
      var formCompra = cont.querySelector('[data-mt-boton]') || cont.querySelector('.mt-prod__form') || caja;
      function actualizarBarra() {
        if (!siempre) {
          var rf = formCompra.getBoundingClientRect();
          cajaVisible = rf.bottom > 0 && rf.top < window.innerHeight;
          barra.classList.toggle('is-visible', !cajaVisible);
          return;
        }
        barra.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.8);
      }
      window.addEventListener('scroll', actualizarBarra, { passive: true });
      window.addEventListener('resize', function () { siempre = getComputedStyle(caja).display === 'contents'; actualizarBarra(); });
      actualizarBarra();
      var barraBtn = barra.querySelector('button');
      if (barraBtn) barraBtn.addEventListener('click', function () {
        /* Si los packs ya se ven en pantalla, la barra compra directamente el pack elegido; si no, lleva hasta ellos */
        var packsEl = cont.querySelector('.mt-packs');
        var botonPrincipal = cont.querySelector('[data-mt-boton]');
        if (packsEl && botonPrincipal && !botonPrincipal.disabled) {
          var rp = packsEl.getBoundingClientRect();
          if (rp.top < window.innerHeight * 0.75 && rp.bottom > 80) { botonPrincipal.click(); return; }
        }
        var destino = packsEl || caja;
        var y = destino.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
  }

  /* ---------- Fecha estimada de entrega ---------- */
  function enEspana() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz) return /^(Europe\/Madrid|Atlantic\/Canary|Africa\/Ceuta)$/.test(tz);
    } catch (e) {}
    return true;
  }
  function initEntrega(root) {
    var es = enEspana();
    (root || document).querySelectorAll('[data-mt-entrega]').forEach(function (el) {
      /* EE. UU. y resto de la UE usan los plazos -ue (7-10, igual que Europa) */
      var min = parseInt(el.getAttribute(es ? 'data-min' : 'data-min-ue'), 10) || 7;
      var max = parseInt(el.getAttribute(es ? 'data-max' : 'data-max-ue'), 10) || 10;
      var caja = el.closest('.mt-envio');
      var txt = caja && caja.querySelector('[data-mt-envio-texto]');
      if (txt) txt.textContent = (txt.getAttribute('data-plantilla') || '').replace('[dias]', min + '-' + max);
      var hoy = new Date();
      var prueba = /[?&]mt-hoy=(\d{4})-(\d{2})-(\d{2})/.exec(window.location.search); /* solo para comprobar fechas */
      if (prueba) hoy = new Date(+prueba[1], +prueba[2] - 1, +prueba[3]);
      var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      function sumar(d) {
        var f = new Date(hoy); f.setDate(f.getDate() + d);
        if (f.getDay() === 0) f.setDate(f.getDate() + 1); /* sin entregas en domingo */
        return f;
      }
      var idioma = (window.mtTextos && window.mtTextos.idioma) || 'es';
      function fmt(f) {
        if (idioma.slice(0, 2) !== 'es') {
          try { return f.toLocaleDateString(idioma, { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) {}
        }
        return dias[f.getDay()] + ' ' + f.getDate() + ' de ' + meses[f.getMonth()];
      }
      var fIni = sumar(min), fFin = sumar(Math.max(min, max));
      /* data-corta: fecha breve ("17 oct") para sitios estrechos como la barra fija */
      var fmtUsar = fmt;
      if (el.hasAttribute('data-corta')) {
        fmtUsar = function (f) { try { return f.toLocaleDateString(idioma, { day: 'numeric', month: 'short' }).replace('.', ''); } catch (e) { return f.getDate() + '/' + (f.getMonth() + 1); } };
      }
      el.textContent = (el.getAttribute('data-plantilla') || '')
        .replace('[inicio]', fmtUsar(fIni))
        .replace('[fin]', fmtUsar(fFin));
      initViaje(caja, fIni, fFin, fmt);
      initNavidad(caja, hoy, Math.max(min, max), sumar, fmt);
    });
  }

  /* Del 1 de noviembre hasta la fecha límite: último día para pedir y recibirlo antes del 24 de diciembre (mismos plazos) */
  function initNavidad(caja, hoy, maxDias, sumar, fmt) {
    var el = caja && caja.querySelector('[data-mt-navidad]');
    if (!el) return;
    var y = hoy.getFullYear();
    var nochebuena = new Date(y, 11, 24);
    if (hoy < new Date(y, 10, 1) || hoy > nochebuena) { el.hidden = true; return; }
    var limite = null;
    for (var d = 0; d <= 60; d++) {
      var pedido = new Date(hoy); pedido.setDate(pedido.getDate() + d);
      var llegada = new Date(pedido); llegada.setDate(llegada.getDate() + maxDias);
      if (llegada.getDay() === 0) llegada.setDate(llegada.getDate() + 1);
      if (llegada > nochebuena) break;
      limite = pedido;
    }
    if (!limite) { el.hidden = true; return; }
    el.textContent = (el.getAttribute('data-plantilla') || '').replace('[fecha]', fmt(limite));
    el.hidden = false;
  }

  /* "¿Viajas pronto?": compara la fecha del viaje con la entrega estimada (mismos plazos que la ficha) */
  function initViaje(caja, fIni, fFin, fmt) {
    var input = caja && caja.querySelector('[data-mt-viaje]');
    var res = caja && caja.querySelector('[data-mt-viaje-res]');
    if (!input || !res) return;
    function d0(f) { return new Date(f.getFullYear(), f.getMonth(), f.getDate()).getTime(); }
    var hoy = new Date();
    input.min = hoy.getFullYear() + '-' + String(hoy.getMonth() + 1).padStart(2, '0') + '-' + String(hoy.getDate()).padStart(2, '0');
    function evaluar() {
      if (!input.value) { res.hidden = true; return; }
      var p = input.value.split('-');
      var viaje = new Date(+p[0], +p[1] - 1, +p[2]).getTime();
      var clave = viaje > d0(fFin) ? 'ok' : (viaje > d0(fIni) ? 'justo' : 'no');
      res.className = 'mt-viaje__res mt-viaje__res--' + clave;
      res.textContent = (res.getAttribute('data-' + clave) || '').replace('[inicio]', fmt(fIni)).replace('[fin]', fmt(fFin));
      res.hidden = false;
    }
    if (!input.dataset.mtListo) { input.dataset.mtListo = '1'; input.addEventListener('change', evaluar); input.addEventListener('input', evaluar); }
    evaluar();
  }

  /* ---------- Ventana 10% ---------- */
  function initPopup() {
    var p = document.querySelector('[data-mt-popup]');
    if (!p || (window.Shopify && window.Shopify.designMode)) return;
    var CLAVE = 'mt-popup-oculto-hasta';
    function leer() { try { return parseInt(localStorage.getItem(CLAVE) || '0', 10); } catch (e) { return 0; } }
    function guardar(dias) { try { localStorage.setItem(CLAVE, String(Date.now() + dias * 864e5)); } catch (e) {} }
    var abierto = false;
    var comprando = false;
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-mt-pack], [data-mt-boton], .mt-pack, [data-mt-upsell], cart-drawer')) comprando = true;
    }, true);
    /* El aviso de cookies tapa el popup: si está a la vista, se espera a que el cliente lo responda */
    function avisoCookies() {
      var b = document.getElementById('shopify-pc__banner');
      return !!(b && b.offsetHeight && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden');
    }
    function abrir(forzar) {
      if (abierto || (comprando && !forzar)) return;
      if (!forzar && avisoCookies()) {
        var espera = setInterval(function () {
          if (avisoCookies()) return;
          clearInterval(espera);
          setTimeout(function () { abrir(); }, 4000);
        }, 1000);
        return;
      }
      abierto = true;
      p.querySelectorAll('img[data-mt-src]').forEach(function (im) { im.src = im.getAttribute('data-mt-src'); im.removeAttribute('data-mt-src'); });
      p.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var input = p.querySelector('input[type="email"]');
      if (input && window.innerWidth > 749) setTimeout(function () { input.focus(); }, 300);
    }
    function cerrar() {
      p.hidden = true;
      document.documentElement.style.overflow = '';
      guardar(parseInt(p.getAttribute('data-dias'), 10) || 7);
    }
    p.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !p.hidden) cerrar(); });

    var copiar = p.querySelector('[data-mt-copiar]');
    if (copiar) copiar.addEventListener('click', function () {
      var txt = copiar.querySelector('[data-mt-copiar-txt]');
      if (navigator.clipboard) navigator.clipboard.writeText(copiar.getAttribute('data-mt-copiar')).then(function () { if (txt) txt.textContent = (window.mtTextos && window.mtTextos.copiado) || '¡Copiado!'; });
    });

    if (p.getAttribute('data-abrir-ya') === 'true') {
      abrir(true);
      if (p.querySelector('[data-mt-popup-exito]')) guardar(365);
      return;
    }
    if (leer() > Date.now()) return;
    var seg = parseInt(p.getAttribute('data-retraso'), 10) || 15;
    setTimeout(function () {
      var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(raiz + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (!c.item_count) abrir();
      }).catch(function () { abrir(); });
    }, seg * 1000);
    if (p.getAttribute('data-salida') === 'true') {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth > 989) abrir();
      });
    }
  }

  function initTodo(root) {
    initEntrega(root);
    initReveal(root);
    initProducto(root);
  }

  /* ---------- Idiomas ---------- */
  function initIdiomas() {
    /* Si el cliente elige idioma a mano, ya no lo cambiamos solos */
    document.addEventListener('submit', function (e) {
      if (e.target.closest && e.target.closest('.mt-idioma__menu, localization-form form')) {
        try { localStorage.setItem('mt-idioma-elegido', '1'); } catch (err) {}
      }
    }, true);
    document.addEventListener('click', function (e) {
      var abierto = document.querySelector('[data-mt-idioma][open]');
      if (abierto && !abierto.contains(e.target)) abierto.removeAttribute('open');
    });
    /* Enlaces internos escritos a mano (/#comprar, /pages/...) → mantener el idioma actual */
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (raiz === '/') return;
    var pref = raiz.replace(/\/$/, '');
    document.querySelectorAll('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h.indexOf('//') === 0 || h === pref || h.indexOf(pref + '/') === 0 || h.indexOf(pref + '#') === 0 || h.indexOf(pref + '?') === 0) return;
      if (/^\/(cdn|checkout|checkouts|services|discount|apps)\b/.test(h)) return;
      a.setAttribute('href', pref + h);
    });
  }

  /* El carrito lateral se vuelve a dibujar al añadir productos: recalcular la fecha de entrega */
  function initCarritoEntrega() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || !window.MutationObserver) return;
    initEntrega(cajon);
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      setTimeout(function () { pendiente = false; cajon.querySelectorAll('.mt-carrito-entrega').forEach(function (el) { if (!el.textContent) initEntrega(el.parentNode); }); }, 50);
    }).observe(cajon, { childList: true, subtree: true });
  }

  /* Recordatorio del carrito: solo en la primera página de una visita nueva, si ya había algo en el carrito */
  function initRecordatorio() {
    var r = document.querySelector('[data-mt-recordatorio]');
    var nueva = false;
    try { nueva = !sessionStorage.getItem('mt-sesion'); sessionStorage.setItem('mt-sesion', '1'); } catch (e) {}
    if (!r || !nueva) return;
    var cajon = document.querySelector('cart-drawer');
    function ocultar() { r.classList.remove('is-visible'); setTimeout(function () { r.hidden = true; }, 300); }
    setTimeout(function () {
      if (cajon && cajon.classList.contains('active')) return;
      r.hidden = false;
      setTimeout(function () { r.classList.add('is-visible'); }, 30);
      setTimeout(ocultar, 12000);
    }, 2500);
    r.querySelector('[data-mt-recordatorio-cerrar]').addEventListener('click', ocultar);
    r.querySelector('[data-mt-recordatorio-abrir]').addEventListener('click', function (e) {
      e.stopPropagation();
      ocultar();
      if (cajon && typeof cajon.open === 'function') { setTimeout(function () { cajon.open(); }, 60); } else { window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; }
    });
  }

  /* Titular según el destino: enlaces de anuncios o vídeos con ?destino=roma cambian el texto pequeño de la ficha.
     Solo ciudades de esta lista (nunca se muestra texto libre de la URL). Se recuerda durante la visita. */
  var DESTINOS = {
    roma: ['Roma', 'Rome', 'Rom', 'Roma'], paris: ['París', 'Paris', 'Paris', 'Parigi'], barcelona: ['Barcelona', 'Barcelone', 'Barcelona', 'Barcellona'],
    madrid: ['Madrid', 'Madrid', 'Madrid', 'Madrid'], londres: ['Londres', 'Londres', 'London', 'Londra'], praga: ['Praga', 'Prague', 'Prag', 'Praga'],
    amsterdam: ['Ámsterdam', 'Amsterdam', 'Amsterdam', 'Amsterdam'], lisboa: ['Lisboa', 'Lisbonne', 'Lissabon', 'Lisbona'], napoles: ['Nápoles', 'Naples', 'Neapel', 'Napoli'],
    florencia: ['Florencia', 'Florence', 'Florenz', 'Firenze'], venecia: ['Venecia', 'Venise', 'Venedig', 'Venezia'], milan: ['Milán', 'Milan', 'Mailand', 'Milano'],
    atenas: ['Atenas', 'Athènes', 'Athen', 'Atene'], berlin: ['Berlín', 'Berlin', 'Berlin', 'Berlino'], viena: ['Viena', 'Vienne', 'Wien', 'Vienna'],
    budapest: ['Budapest', 'Budapest', 'Budapest', 'Budapest'], estambul: ['Estambul', 'Istanbul', 'Istanbul', 'Istanbul'], 'nueva-york': ['Nueva York', 'New York', 'New York', 'New York'],
    bangkok: ['Bangkok', 'Bangkok', 'Bangkok', 'Bangkok'], marrakech: ['Marrakech', 'Marrakech', 'Marrakesch', 'Marrakech']
  };
  var PLANTILLA_DESTINO = { es: '✈ ¿Viajas a {c}?', fr: '✈ Vous partez à {c} ?', de: '✈ Reise nach {c}?', it: '✈ Vai a {c}?' };
  function initDestino() {
    var clave = null;
    var m = /[?&]destino=([a-z-]{2,20})/.exec(window.location.search.toLowerCase());
    try {
      if (m && DESTINOS[m[1]]) { clave = m[1]; sessionStorage.setItem('mt-destino', clave); }
      else { clave = sessionStorage.getItem('mt-destino'); }
    } catch (e) { if (m && DESTINOS[m[1]]) clave = m[1]; }
    if (!clave || !DESTINOS[clave]) return;
    var idioma = ((window.mtTextos && window.mtTextos.idioma) || 'es').slice(0, 2);
    var i = { es: 0, fr: 1, de: 2, it: 3 }[idioma];
    if (i === undefined) return;
    var texto = PLANTILLA_DESTINO[idioma].replace('{c}', DESTINOS[clave][i]);
    document.querySelectorAll('.mt-prod__info > .mt-eyebrow').forEach(function (el) { el.textContent = texto; el.classList.add('mt-eyebrow--destino'); });
  }

  /* Planes (viaje, fiesta, día a día): pestañas, ?uso= desde los anuncios y botón que elige el pack recomendado */
  function initPlanes() {
    var claves = ['viaje', 'fiesta', 'dia'];
    var uso = null;
    var m = /[?&]uso=([a-z]{3,8})/.exec(window.location.search.toLowerCase());
    try {
      if (m && claves.indexOf(m[1]) !== -1) { uso = m[1]; sessionStorage.setItem('mt-uso', uso); }
      else { uso = sessionStorage.getItem('mt-uso'); }
    } catch (e) { if (m && claves.indexOf(m[1]) !== -1) uso = m[1]; }
    if (claves.indexOf(uso) === -1) uso = null;

    /* Titular del producto adaptado al plan (si no viene ya un destino de viaje) */
    var lema = uso && window.mtTextos && window.mtTextos['uso_' + uso];
    if (lema && !document.querySelector('.mt-eyebrow--destino')) {
      document.querySelectorAll('.mt-prod__info > .mt-eyebrow').forEach(function (el) { el.textContent = lema; el.classList.add('mt-eyebrow--destino'); });
    }

    /* Quien llega desde un vídeo de fiesta: en el selector se destaca la correa (en la fiesta lo que más se roba es el móvil) */
    if (uso === 'fiesta' && window.mtTextos && window.mtTextos.sel_fiesta) {
      document.querySelectorAll('.mt-selector__op[data-mt-sel-n="3"]').forEach(function (op) {
        if (op.querySelector('.mt-selector__chip')) return;
        var chip = document.createElement('em');
        chip.className = 'mt-selector__chip';
        chip.textContent = window.mtTextos.sel_fiesta;
        op.classList.add('is-sugerido');
        op.appendChild(chip);
      });
    }

    /* Chips "Ideal para" del producto: abren ese plan y bajan a la sección (sin sección, el enlace no hace nada) */
    var seccionPlanes = document.querySelector('[data-mt-planes]');
    /* Sin sección de planes (ficha del cinturón): los chips abren la foto de la galería que explica los usos */
    var miniUsos = document.querySelector('[data-mt-mini][data-src*="planes"]');
    document.querySelectorAll('[data-mt-plan-ir]').forEach(function (a) {
      if (!seccionPlanes && miniUsos) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          miniUsos.click();
          var gal = document.querySelector('.mt-prod__galeria');
          if (gal) gal.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
        return;
      }
      if (!seccionPlanes) { a.removeAttribute('href'); a.classList.add('is-fijo'); return; }
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var tab = seccionPlanes.querySelector('[data-mt-plan-tab="' + a.getAttribute('data-mt-plan-ir') + '"]');
        if (tab) tab.click();
        seccionPlanes.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    document.querySelectorAll('[data-mt-planes]').forEach(function (caja) {
      var tabs = caja.querySelectorAll('[data-mt-plan-tab]');
      function abrir(c) {
        tabs.forEach(function (t) {
          var si = t.getAttribute('data-mt-plan-tab') === c;
          t.classList.toggle('is-activa', si);
          t.setAttribute('aria-selected', si ? 'true' : 'false');
        });
        caja.querySelectorAll('[data-mt-plan]').forEach(function (p) {
          var si = p.getAttribute('data-mt-plan') === c;
          p.hidden = !si;
          p.classList.toggle('is-activo', si);
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var c = t.getAttribute('data-mt-plan-tab');
          abrir(c);
          try { sessionStorage.setItem('mt-uso', c); } catch (e) {}
        });
      });
      if (uso) abrir(uso);

      caja.querySelectorAll('[data-mt-plan-elegir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var r = document.querySelector('[data-mt-pack][value="' + b.getAttribute('data-mt-plan-elegir') + '"]');
          if (!r) { window.location.href = b.getAttribute('data-url'); return; }
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
          var packs = document.getElementById('mt-packs');
          if (packs) packs.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          var tarjeta = r.closest('.mt-pack');
          if (tarjeta) setTimeout(function () { tarjeta.classList.add('mt-pack--destello'); setTimeout(function () { tarjeta.classList.remove('mt-pack--destello'); }, 1900); }, 500);
        });
      });
    });
  }

  /* ¿Cuánto te juegas?: suma el efectivo elegido y la tasa oficial del pasaporte; tarjetas y DNI se muestran como trámites */
  function initRiesgo() {
    document.querySelectorAll('[data-mt-riesgo]').forEach(function (caja) {
      var idioma = caja.getAttribute('data-idioma') || 'es';
      var tasa = parseInt(caja.getAttribute('data-pasaporte'), 10) || 0;
      var fmt;
      var moneda = caja.getAttribute('data-moneda') || 'EUR';
      try { fmt = new Intl.NumberFormat(idioma, { style: 'currency', currency: moneda, maximumFractionDigits: 0 }); } catch (e) { fmt = { format: function (n) { return n + ' ' + moneda; } }; }
      var ef = caja.querySelector('[data-mt-r-ef]');
      var efValor = caja.querySelector('[data-mt-r-ef-valor]');
      var total = caja.querySelector('[data-mt-r-total]');
      var lista = caja.querySelector('[data-mt-r-tramites]');
      var marcado = function (k) { var c = caja.querySelector('[data-mt-r="' + k + '"]'); return c && c.checked; };
      function calcular() {
        var euros = parseInt(ef.value, 10) || 0;
        efValor.textContent = fmt.format(euros);
        if (marcado('pasaporte')) euros += tasa;
        total.textContent = fmt.format(euros);
        lista.textContent = '';
        ['pasaporte', 'dni', 'tarjetas'].forEach(function (k) {
          if (!marcado(k)) return;
          var li = document.createElement('li');
          li.textContent = lista.getAttribute('data-' + k);
          lista.appendChild(li);
        });
      }
      caja.querySelectorAll('input').forEach(function (i) { i.addEventListener('input', calcular); i.addEventListener('change', calcular); });
      calcular();
      /* En la ficha del producto, el botón baja a los packs sin recargar */
      var btn = caja.querySelector('[data-mt-r-btn]');
      btn.addEventListener('click', function (e) {
        var packs = document.getElementById('mt-packs');
        if (!packs) return;
        e.preventDefault();
        packs.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  /* Garantía Nómada: el sello de la foto y el texto "Garantía 3 años" bajo el precio abren la explicación */
  function initGarantia() {
    var dlg = document.querySelector('[data-mt-garantia]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    document.querySelectorAll('.mt-prod__precio-nota').forEach(function (nota) {
      var partes = nota.textContent.split('·');
      var i = -1;
      partes.forEach(function (p, j) { if (/garant|warrant/i.test(p)) i = j; });
      if (i === -1) return;
      nota.textContent = '';
      partes.forEach(function (p, j) {
        if (j) nota.appendChild(document.createTextNode('·'));
        if (j !== i) { nota.appendChild(document.createTextNode(p)); return; }
        var lead = p.match(/^\s*/)[0], trail = p.match(/\s*$/)[0];
        nota.appendChild(document.createTextNode(lead));
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mt-gardlg__enlace';
        b.setAttribute('data-mt-garantia-abrir', '');
        b.setAttribute('aria-haspopup', 'dialog');
        b.textContent = p.trim() + ' ⓘ';
        nota.appendChild(b);
        nota.appendChild(document.createTextNode(trail));
      });
    });
    document.querySelectorAll('[data-mt-garantia-abrir]').forEach(function (b) {
      b.addEventListener('click', function () { dlg.showModal(); });
    });
    dlg.querySelector('[data-mt-garantia-cerrar]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  /* Aviso de zona de envío: quien está fuera de la Península, Baleares o la UE lo sabe antes de llegar al pago */
  function initAvisoZona() {
    var el = document.querySelector('[data-mt-aviso-zona]');
    if (!el) return;
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    if (window.mtTextos && window.mtTextos.pais === 'US') return;
    if (!tz) return;
    /* con el mercado de EE. UU. activo, sus zonas horarias también están dentro */
    if (el.hasAttribute('data-us') && /^(America\/(New_York|Detroit|Chicago|Denver|Boise|Phoenix|Los_Angeles|Anchorage|Juneau|Sitka|Nome|Yakutat|Metlakatla|Menominee|Indiana\/.+|Kentucky\/.+|North_Dakota\/.+|Adak)|Pacific\/Honolulu)$/.test(tz)) return;
    var ue = ['Madrid', 'Lisbon', 'Paris', 'Berlin', 'Busingen', 'Rome', 'Brussels', 'Amsterdam', 'Luxembourg', 'Vienna', 'Dublin', 'Copenhagen', 'Stockholm', 'Helsinki', 'Mariehamn', 'Tallinn', 'Riga', 'Vilnius', 'Warsaw', 'Prague', 'Bratislava', 'Budapest', 'Ljubljana', 'Zagreb', 'Bucharest', 'Sofia', 'Athens', 'Nicosia', 'Famagusta', 'Malta'];
    var dentro = ue.some(function (c) { return tz === 'Europe/' + c || tz === 'Asia/' + c; });
    if (!dentro) el.hidden = false;
  }

  /* Fotos de clientes de las opiniones (Judge.me): miniaturas con su nota real y visor a pantalla completa */
  function initFotosResenas() {
    document.querySelectorAll('[data-mt-fotos]').forEach(function (caja) {
      var grid = caja.querySelector('[data-mt-fotos-grid]');
      var tienda = (window.Shopify && window.Shopify.shop) || '';
      var excluir = (caja.getAttribute('data-excluir') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var url = 'https://judge.me/reviews/reviews_for_widget?url=' + tienda + '&shop_domain=' + tienda + '&platform=shopify&page=1&per_page=30&product_id=' + caja.getAttribute('data-producto');
      function cargar() {
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          var fotos = [];
          (d.photo_gallery || []).forEach(function (rev) {
            (rev.pictures_urls || []).forEach(function (p) {
              var src = p.original || p.huge;
              if (!src || excluir.some(function (x) { return src.indexOf(x) !== -1; })) return;
              fotos.push({ src: src, nota: parseInt(rev.rating, 10) || 5 });
            });
          });
          if (!fotos.length) return;
          var conEstrellas = caja.getAttribute('data-estrellas') === 'true';
          /* Con estrellas: de mayor a menor nota (todas siguen en el visor, también las de nota baja) */
          if (conEstrellas) fotos = fotos.map(function (f, k) { f.k = k; return f; }).sort(function (a, b) { return (b.nota - a.nota) || (a.k - b.k); });
          var pintaEstrellas = function (n) { return '<span class="mt-fotos__nota" aria-label="' + n + '/5">' + '★★★★★'.slice(0, n) + '<i>' + '★★★★★'.slice(n) + '</i></span>'; };
          fotos.slice(0, 12).forEach(function (f, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'mt-fotos__item';
            var alt = caja.getAttribute('data-alt') || '';
            b.setAttribute('aria-label', alt + (conEstrellas ? ' · ' + f.nota + '/5' : ''));
            b.innerHTML = '<img loading="lazy" alt="" width="160" height="160">' + (conEstrellas ? pintaEstrellas(f.nota) : '');
            b.querySelector('img').src = f.src + '_220x220.jpg';
            b.addEventListener('click', function () { abrir(fotos, i); });
            grid.appendChild(b);
          });
          caja.hidden = false;
        }).catch(function () {});
      }
      function abrir(fotos, i) {
        var v = document.createElement('div');
        v.className = 'mt-visor';
        v.setAttribute('role', 'dialog');
        v.setAttribute('aria-modal', 'true');
        v.innerHTML = '<button type="button" class="mt-visor__cerrar" aria-label="' + (caja.getAttribute('data-cerrar') || '×') + '">×</button><img alt=""><p class="mt-visor__nota"></p>';
        var img = v.querySelector('img');
        var notaV = v.querySelector('.mt-visor__nota');
        var conNota = caja.getAttribute('data-estrellas') === 'true';
        function ver(k) {
          i = (k + fotos.length) % fotos.length; img.src = fotos[i].src;
          if (conNota) { var n = fotos[i].nota; notaV.innerHTML = '★★★★★'.slice(0, n) + '<i>' + '★★★★★'.slice(n) + '</i> <small>' + n + '/5 · ' + (i + 1) + '/' + fotos.length + '</small>'; } else notaV.remove();
        }
        function cerrar() { document.removeEventListener('keydown', tecla); v.remove(); document.documentElement.style.overflow = ''; }
        function tecla(e) { if (e.key === 'Escape') cerrar(); if (e.key === 'ArrowRight') ver(i + 1); if (e.key === 'ArrowLeft') ver(i - 1); }
        v.addEventListener('click', function (e) { if (e.target === v || e.target.classList.contains('mt-visor__cerrar')) cerrar(); else if (e.target === img && fotos.length > 1) ver(i + 1); });
        document.addEventListener('keydown', tecla);
        ver(i);
        document.body.appendChild(v);
        document.documentElement.style.overflow = 'hidden';
        v.querySelector('.mt-visor__cerrar').focus();
      }
      if ('IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { o.disconnect(); cargar(); } }, { rootMargin: '600px' });
        o.observe(caja.parentElement || caja);
      } else { cargar(); }
    });
  }

  /* Página "Seguir mi pedido": abre el número en 17TRACK (servicio gratuito) en otra pestaña */
  function initSeguimiento() {
    document.querySelectorAll('[data-mt-seguimiento]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = f.querySelector('input[name="nums"]');
        var err = f.querySelector('[data-mt-seg-error]');
        var num = (input.value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        if (num.length < 6) { if (err) err.hidden = false; input.focus(); return; }
        if (err) err.hidden = true;
        window.open('https://t.17track.net/' + (f.getAttribute('data-idioma') || 'es') + '#nums=' + encodeURIComponent(num), '_blank', 'noopener');
      });
    });
  }

  /* Compartir con quien viaja contigo: menú nativo del móvil o WhatsApp */
  function initCompartir() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-mt-compartir]') : null;
      if (!b) return;
      var url = b.getAttribute('data-url'), texto = b.getAttribute('data-texto') || '';
      if (navigator.share) {
        navigator.share({ text: texto, url: url }).catch(function () {});
      } else {
        window.open('https://wa.me/?text=' + encodeURIComponent(texto + ' ' + url), '_blank', 'noopener');
      }
    });
  }

  /* Si el cliente cambia de pestaña con algo en el carrito, el título de la pestaña se lo recuerda */
  function initTituloPestana() {
    var aviso = window.mtTextos && window.mtTextos.titulo_vuelve;
    if (!aviso) return;
    var original = document.title;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (document.querySelector('#cart-icon-bubble .cart-count-bubble')) { original = document.title; document.title = aviso; }
      } else if (document.title === aviso) {
        document.title = original;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initIdiomas();
    initRecordatorio();
    initTituloPestana();
    initCompartir();
    initDestino();
    initPlanes();
    initGarantia();
    initRiesgo();
    initSeguimiento();
    initFotosResenas();
    initAvisoZona();
    initCarritoEntrega();
    initTodo(document);
    initParallax();
    initPopup();
  });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();

/* Nómada: quien tiene el navegador en francés, alemán o italiano y entra a una página en español
   (enlace compartido o de un vídeo) ve un aviso para cambiar a su idioma. Usa los enlaces hreflang de la página. */
(function () {
  var T = {
    fr: ['Voir cette page en français ?', 'Oui', 'Non merci'],
    de: ['Diese Seite auf Deutsch ansehen?', 'Ja', 'Nein, danke'],
    it: ['Vedere questa pagina in italiano?', 'Sì', 'No, grazie']
  };
  function iniciar() {
    if ((document.documentElement.lang || '').slice(0, 2) !== 'es') return;
    try { if (localStorage.getItem('mt-idioma-aviso')) return; } catch (e) {}
    var langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']).map(function (l) { return String(l).slice(0, 2).toLowerCase(); });
    var l = null;
    for (var i = 0; i < langs.length; i++) { if (langs[i] === 'es') return; if (T[langs[i]]) { l = langs[i]; break; } }
    if (!l) return;
    var alt = document.querySelector('link[rel="alternate"][hreflang="' + l + '"]');
    if (!alt || !alt.href) return;
    var t = T[l], caja = document.createElement('div');
    caja.className = 'mt-idioma-aviso'; caja.setAttribute('role', 'dialog'); caja.setAttribute('lang', l);
    caja.innerHTML = '<span></span><a class="mt-idioma-aviso__si"></a><button type="button" class="mt-idioma-aviso__no"></button>';
    caja.querySelector('span').textContent = t[0];
    var si = caja.querySelector('a'); si.textContent = t[1]; si.href = alt.href + (location.search || '');
    var no = caja.querySelector('button'); no.textContent = t[2];
    var cerrar = function () { try { localStorage.setItem('mt-idioma-aviso', '1'); } catch (e) {} caja.remove(); };
    no.addEventListener('click', cerrar);
    document.body.appendChild(caja);
    requestAnimationFrame(function () { caja.classList.add('is-visible'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(iniciar, 1200); });
  else setTimeout(iniciar, 1200);
})();
